module.exports = __webpack_public_path__ + "static/media/Direct_Access_to_Management.65e49d41.jpg";